import { useEffect } from "react";
import { EMPTY_OBJECT } from "../scene/sceneConstants";

export function useViewportBodyVisibilitySync({
  safeBodies,
  sceneObjectsRef,
  showViewportBodies,
  structureChangeTick,
}) {
  useEffect(() => {
    const seen = new Set();
    Object.values(sceneObjectsRef.current || EMPTY_OBJECT).forEach((obj) => {
      if (!obj || seen.has(obj)) return;
      seen.add(obj);
      obj.visible = showViewportBodies;
    });
  }, [safeBodies, sceneObjectsRef, showViewportBodies, structureChangeTick]);
}
